import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { BucketPaneEl } from "common/widgets/bucket-pane";
export function template() {
  const { isMenuOpen } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-bucket-selector"
  }, this.attr(`label`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-bucket-selector-label"
  }, this.attr(`label`)) : null, /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      theme: SelectTheme.Secondary,
      open: isMenuOpen,
      "selected-option": this.helpers.getDisplayedBucketLabel(),
      tooltip: { text: this.attr(`tooltip-text`) }
    },
    on: { menuChange: this.helpers.changeMenu }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-bucket-selector-container",
    attrs: { slot: `body` }
  }, isMenuOpen ? /* @__PURE__ */ jsx(BucketPaneEl, {
    attrs: this.helpers.getBucketPaneAttributes(),
    on: {
      changeSelectedBucket: this.helpers.propagateEvent,
      resetBucket: this.helpers.propagateEvent
    }
  }) : null)));
}
